// extracted by mini-css-extract-plugin
var _1 = "fDcLI";
export { _1 as "base" }
